import React from 'react';

import { OptionsMenu, OptionsMenuButton } from '@pkg/components';
import { type Collectible } from '@pkg/graphql/codegen/graphql';
import { useGetPortfolioLid } from '@pkg/hooks/liquid-id/useGetPortfolioLid.ts';
import { useLiquidIdAddItem } from '@pkg/hooks/liquid-id/useLiquidIdAddItem.ts';
import { useLiquidIdRemoveItem } from '@pkg/hooks/liquid-id/useLiquidIdRemoveItem.ts';
import { useAppSelector } from '@pkg/hooks/redux/useAppSelector.ts';

import { useToggleCollectiblesMutation } from '@app/store/zustand';

export interface NftManagerOptionsMenuProps {
    item: Collectible;
}
export const NftManagerOptionsMenu = ({ item }: NftManagerOptionsMenuProps) => {
    const { hideTokens, showTokens } = useToggleCollectiblesMutation();

    const { showCSSLiquidID } = useAppSelector((state) => state.featureFlags.features);

    const lidItemString = item.id;
    const { mutate: addItem, isPending: isLoadingAdd } = useLiquidIdAddItem();
    const { mutate: removeItem, isPending: isLoadingRemove } = useLiquidIdRemoveItem();
    const { data: lidData, isLoading: isLoadingCurr } = useGetPortfolioLid();

    const loading = isLoadingAdd || isLoadingRemove || isLoadingCurr;
    const addedToLid = lidData?.items.some((item) => item === lidItemString);

    const handleActionItem = () => {
        if (addedToLid) {
            removeItem(lidItemString);
        } else {
            addItem(lidItemString);
        }
    };

    function toggleHide() {
        const itemId = item.id;
        if (!itemId) return;

        const collectibleIds = [itemId];
        if (item.hidden) {
            void showTokens({ collectiblesIdsToShow: collectibleIds });
        } else {
            void hideTokens({ collectiblesIdsToHide: collectibleIds });
        }
    }

    return (
        <OptionsMenu>
            <OptionsMenuButton onClick={() => toggleHide()}>
                {item.hidden ? 'Show on profile' : 'Hide from profile'}
            </OptionsMenuButton>
            {showCSSLiquidID && (
                <OptionsMenuButton disabled={loading} onClick={handleActionItem}>
                    {addedToLid ? 'Remove from Liquid ID' : 'Add to Liquid ID'}
                </OptionsMenuButton>
            )}
        </OptionsMenu>
    );
};
